<script setup>
import axios from "@axios"
const props = defineProps({
  emailTemplateName: {
    type: String,
    required: true
  },
  emailSubject: {
    type: String,
    required: true
  },
  emailTo: {
    type: String,
    required: true
  },
  emailCc: {
    type: String,
    required: true
  },
  isDialogVisible: {
    type: Boolean,
    required: true
  },
  member: {
    type: Object
  },
  userGroup: {
    type: Object
  },
})

const emit = defineEmits([
  'update:isDialogVisible',
  'confirm',
  'cancel'
])

const updateModelValue = val => {
  emit('update:isDialogVisible', val)
}
const onConfirmation = () => {
  emit('confirm', true)
  updateModelValue(false)
}
const onCancel = () => {
  emit('cancel', true)
  emit('update:isDialogVisible', false)
}
const onClose = () => {
  emit('close', true)
  emit('update:isDialogVisible', false)
}

const emailTemplateHtml = ref('')

const fetchEmailTemplate = async () => {
  let reducedUserGroup = {
    name: props.userGroup.name,
    joinUrl: props.userGroup.joinUrl
  }
  let reducedUser = {
    name: props.member.name,
    email: props.member.email
  }

  //axios call to get the email template html from /email_templates/enterpriseGroupInviteMember
  await axios.get('/email_templates/'+props.emailTemplateName, {
    params: {
      group: JSON.stringify(reducedUserGroup),
      user: JSON.stringify(reducedUser)
    }
  })
    .then(response => {
      console.log(response.data)
      emailTemplateHtml.value = response.data
    })
    .catch(error => {
      console.log(error)
    })

}

onMounted(() => {
  fetchEmailTemplate()
})
</script>

<template>
  <!-- 👉 Confirm Dialog -->
  <VDialog
    max-width="1000"
    :model-value="props.isDialogVisible"
    persistent
  >
    <VCard class=" px-2 py-2">
      <VCardText>
        <div><b>to:</b> {{ props.emailTo }}</div>
        <div><b>cc:</b> {{ props.emailCc }}</div>
        <div><b>Subject:</b> {{ props.emailSubject }}</div>
        <div
          class="mt-2 "
          v-html="emailTemplateHtml"
        />
      </VCardText>

      <!--      <VCardActions class="align-center justify-center gap-2"> -->
      <!--        <VBtn -->
      <!--          color="secondary" -->
      <!--          variant="tonal" -->
      <!--          @click="onClose" -->
      <!--        > -->
      <!--          Close -->
      <!--        </VBtn> -->
      <!--      </VCardActions> -->
    </VCard>
    <VBtn
      icon="$close"
      size="large"
      variant="text"
      color="secondary"
      class="dialog-close-btn"
      @click="onClose"
    >
      <VIcon>mdi-close</VIcon>
    </VBtn>
  </VDialog>
</template>

<style scoped>
.dialog-close-btn {
  position: fixed;
  right: 6px;
  top: 6px;
}
</style>
